import PAGE_API from '@/apis/pageApi';
import { getLastPath } from '@/utils/url';

export default [
  {
    path: '/',
    name: '首页',
    redirect: PAGE_API.home.path,
  },

  // 登录后首页
  {
    path: PAGE_API.home.path,
    name: '首页',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/home'),
    children: [
      {
        path: '',
        redirect: PAGE_API.home.children.barManager.path,
      },
      {
        path: PAGE_API.home.children.barManager.path,
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/barManager'),
        children: [
          // 登录后首页重定向网吧管理页面
          {
            path: '',
            redirect: PAGE_API.home.children.barManager.children.index.path,
          },
          // 第一级菜单列表
          {
            path: getLastPath(PAGE_API.home.children.barManager.children.index.path),
            meta: {
              notCache: true,
            },
            component: () => import('@/pages/barManager/default'),
            children: [
              {
                path: '',
                redirect: PAGE_API.home.children.barManager.children.index.children.allBar.path,
              },
              // 全部网吧
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.allBar.path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/allBar/index'),
              },
              // 最近远程
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.recentRemote.path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/recentRemote/index'),
              },
              // 服务器离线的网吧
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.serverOfflineBar.path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/serverOfflineBar/index'),
              },
              // 服务器标签管理
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.serverLabelManage.path
                ),
                meta: {
                  notCache: true,
                },
                component: () =>
                  import('@/pages/barManager/default/router/serverLabelManage/index'),
              },
              // 远程协助记录
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.remoteRecord.path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/remoteRecord/index'),
              },
              // 分组网吧列表
              {
                path:
                  getLastPath(
                    PAGE_API.home.children.barManager.children.index.children.groupBar.path
                  ) + '/:id',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/groupBar/index'),
              },
              // 分组网吧列表
              {
                path: getLastPath(
                  PAGE_API.home.children.barManager.children.index.children.searchBar.path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/searchBar/index'),
              },
              // 网吧内容页
              {
                path:
                  getLastPath(
                    PAGE_API.home.children.barManager.children.index.children.barDetails.path
                  ) + '/:id',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/barManager/default/router/barDetails/index'),
              },
            ],
          },
        ],
      },
      // 员工管理
      {
        path: getLastPath(PAGE_API.home.children.staffManage.path),
        name: '员工管理',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/emplyeeManage'),
      },
      // 网吧留言板
      // {
      //     path: getLastPath(PAGE_API.home.children.messageBoard.path),
      //     name: '网吧留言板',
      //     meta: {
      //         notCache: true
      //     },
      //     component: () =>
      //         import('@/pages/messageBoard'),
      //         children: [
      //             {
      //                 path: getLastPath(PAGE_API.home.children.messageBoard.children.barMessage.path),
      //                 meta: {
      //                     notCache: true,
      //                 },
      //                 component: () =>
      //                     import('@/pages/messageBoard/barMessage')
      //             }
      //         ]
      // },
      //账号安全
      {
        path: getLastPath(PAGE_API.home.children.accountSafe.path),
        name: '账号安全',
        meta: {
          notCache: true,
          // title: '网吧管理'
        },
        component: () => import('@/pages/accountSafe'),
      },
      // 操作日志
      {
        path: getLastPath(PAGE_API.home.children.operationLog.path),
        name: '操作日志',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/operationLog'),
      },
      {
        path: getLastPath(PAGE_API.home.children.download.path),
        name: '下载安全中心客户端',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/download'),
      },
      {
        path: getLastPath(PAGE_API.home.children.debugModel.path),
        name: '调试模式',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/debugMode'),
      },
      // 安全中心
      {
        path: getLastPath(PAGE_API.home.children.securityCenter.path),
        name: '安全中心',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/securityCenter'),
        children: [
          {
            path: '',
            redirect: PAGE_API.home.children.securityCenter.children.index.path,
          },
          // 第一级菜单列表
          {
            path: getLastPath(PAGE_API.home.children.securityCenter.children.index.path),
            meta: {
              notCache: true,
            },
            component: () => import('@/pages/securityCenter/default'),
            children: [
              {
                path: '',
                redirect: '/home/securityCenter/index/barList',
              },
              //网吧管理
              {
                path: '/home/securityCenter/index/barList',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/barList/index'),
              },
              //我的安全规则
              {
                path:'/home/securityCenter/index/safetyRules',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/safetyRules/index'),
              },
              // 规则大厅
              {
                path:'/home/securityCenter/index/shareRules',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/shareRules/index'),
              },
               // 规则分组管理
               {
                path:'/home/securityCenter/index/barManageSecurityGroup',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/barManageSecurityGroup/index'),
              },
              // 开机通道
              {
                path: '/home/securityCenter/index/powerChannel',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/powerChannel/index'),
              },
              {
                path:'/home/securityCenter/index/download',
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/download'),
              },
              // //DLL注入
              // {
              //   path: getLastPath(
              //     PAGE_API.home.children.securityCenter.children.index.children[4].path
              //   ),
              //   meta: {
              //     notCache: true,
              //   },
              //   component: () => import('@/pages/securityCenter/DLL/index'),
              // },
              //开机通道
              
              // 网吧管理与安全组
              {
                path: getLastPath(
                  PAGE_API.home.children.securityCenter.children.index.children[2].path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/barManageSecurityGroup/index'),
              },
              
              {
                path: getLastPath(
                  PAGE_API.home.children.aloneClient.children.index.children[1].path
                ),
                meta: {
                  notCache: true,
                },
                component: () => import('@/pages/securityCenter/client/index'),
              },
             
              // {
              //   path: getLastPath(
              //     PAGE_API.home.children.aloneClient.children.index.children[2]
              //       .path
              //   ),
              //   meta: {
              //     notCache: true,
              //   },
              //   component: () =>
              //     import('@/pages/securityCenter/clientHardware/index'),
              // },
              // {
              //     path: getLastPath(
              //         PAGE_API.home.children.aloneClient
              //         .children.index.children[3].path
              //     ),
              //     meta: {
              //         notCache: true,
              //     },
              //     component: () =>
              //         import("@/pages/securityCenter/clientSoftware/index"),
              // },
            ],
          },
        ],
      },
      {
        path: getLastPath(PAGE_API.home.children.threeTierMission.path),
        name: '三层任务',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/threeTierMission'),
      },
      {
        path: getLastPath(PAGE_API.home.children.fileManage.path),
        name: '任务管理',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/threeTierMission/fileManage/index'),
      },
      {
        path: getLastPath(PAGE_API.home.children.userInfo.path),
        name: '用户中心',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/userInfo'),
      },
      {
        path: getLastPath(PAGE_API.home.children.OEMInfo.path),
        name: 'OEM信息',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/OEMInfo'),
      },
      {
        path: getLastPath(PAGE_API.home.children.VIPInfo.path),
        name: 'VIP充值',
        meta: {
          notCache: true,
        },
        component: () => import('@/pages/VIPInfo'),
      },
    ],
  },
  // 登录页
  {
    path: PAGE_API.login.path,
    name: '登录',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/login'),
  },
  {
    path: '/log',
    name: '日志',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/log'),
  },
  {
    path: '/home/tree',
    name: '进程树',
    meta: {
      notCache: true,
      title: '进程树',
    },
    component: () => import('@/pages/tree'),
  },
  //注册页
  {
    path: PAGE_API.register.path,
    name: '注册',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/register'),
  },
  {
    path: PAGE_API.terms.path,
    name: 'terms',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/register/terms'),
  },
  // 重置密码页
  {
    path: PAGE_API.reset.path,
    name: '重置密码',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/reset'),
  },
  // 重置密码页
  {
    path: PAGE_API.wxBind.path,
    name: '重置密码',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/wxBind'),
  },
  //账号解冻
  {
    path: PAGE_API.accountThaw.path,
    name: '账号解冻',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/accountThaw'),
  },
  {
    path: PAGE_API.message.path,
    name: '网吧留言板',
    meta: {
      notCache: true,
    },
    component: () => import('@/pages/messageBoard/barMessage/messageLeft'),
  },
  {
    path: '*',
    name: 'error_404',
    redirect: '/',
    meta: {},
  },
];
